<template>
  <div style="max-width: 500px" class="mx-auto">
    <div class="pa-4 Kanit">
      <div v-if="!isEdit">
        <div class="pt-5">
          <v-btn class="Kanit mb-3" @click="back" text color="primary">
            <v-icon>mdi-chevron-left</v-icon>
            กลับ
          </v-btn>
        </div>
        <div class="mb-5" style="font-size: 22px">ที่อยู่จัดส่ง</div>
        <div
          @click="selectDefault(k)"
          style="cursor: pointer; position: relative"
          class="mb-5"
          v-for="(address, k) in $store.state.address"
          :key="k"
        >
          <div
            v-if="address.default"
            class="text-right primary--text"
            style="font-size: 16px; position: absolute; right: 9px; top: -23px"
          >
            [ค่าเริ่มต้น]
          </div>

          <v-card
            :style="
              address.default
                ? 'color: white;'
                : 'color: grey; border-color: grey !important'
            "
            style="border-radius: 12px"
            outlined
            :color="address.default ? '#5D91D3' : 'white'"
            :dark="address.default"
            class="pa-2"
          >
            <div
              class="pr-1 pt-1"
              style="position: absolute; right: 0px; top: 0px"
            >
              <v-btn
                @click.stop="editAddress(address, k)"
                class="mr-2"
                small
                icon
                outlined
                ><v-icon small>mdi-pencil</v-icon></v-btn
              >
              <v-btn @click="deleteAddress(k)" small icon outlined
                ><v-icon small>mdi-delete</v-icon></v-btn
              >
            </div>
            <div>
              <div>{{ address.name }}</div>
              <span class="pr-2">{{ address.address }}</span>
              <span class="pr-2"
                >{{ address.province === "กรุงเทพมหานคร" ? "แขวง" : "ตำบล"
                }}{{ address.subDistrict }}</span
              >

              <span class="pr-2"
                >{{ address.province === "กรุงเทพมหานคร" ? "เขต" : "อำเภอ"
                }}{{ address.district }}</span
              >
              <span class="pr-2">จังหวัด{{ address.province }}</span>
              <span>{{ address.postCode }}</span>

              <br />
              เบอร์โทรศัพท์ {{ address.phoneNumber }}
            </div>
          </v-card>
        </div>
        <div class="mt-5">
          <v-btn
            :disabled="$store.state.address.length >= 5"
            @click="createAddress"
            outlined
            color="primary"
            style="font-size: 19px"
            block
            >เพิ่มที่อยู่</v-btn
          >
        </div>
        <div class="mt-10">
          <v-btn
            :loading="saveloading"
            @click="saveAllAddress"
            color="primary"
            style="font-size: 19px"
            block
            >บันทึก</v-btn
          >
        </div>
      </div>
      <div v-else>
        <RewardAddressEdit
          @oncreate="onCreateAddress"
          @onedit="onEditAddress"
          :type="editType"
          :dataedit="editingAddress"
          @close="isEdit = false"
        ></RewardAddressEdit>
      </div>
    </div>
  </div>
</template>

<script>
import RewardAddressEdit from "./RewardAddressEdit.vue";
import axios from "axios";
export default {
  components: {
    RewardAddressEdit,
  },
  data() {
    return {
      editingAddress: "",
      editingIndex: "",
      editType: "create",
      isEdit: false,
      saveloading: false,
      tempaddress: "",
    };
  },
  computed: {
    isAnyDefaultAddress() {
      return (
        this.$store.state.address &&
        this.$store.state.address.length &&
        this.$store.state.address.some((el) => el.default)
      );
    },
    address() {
      return this.$store.state.address;
    },
  },
  mounted() {
    this.tempaddress = JSON.stringify(this.address);
  },
  methods: {
    autoDefault() {
      if (
        this.$store.state.address &&
        this.$store.state.address.length &&
        !this.isAnyDefaultAddress
      ) {
        this.$store.state.address[0].default = true;
      }
    },
    back() {
      this.$store.state.address = JSON.parse(this.tempaddress);
      this.$emit("close");
    },
    deleteAddress(k) {
      this.$swal
        .fire({
          text: "ยืนยันการลบ ?",
          showCancelButton: true,
        })
        .then((result) => {
          if (result.value) {
            this.$store.state.address.splice(k, 1);
            this.saveAllAddress(true);
          }
        });
    },
    selectDefault(index) {
      this.address.forEach((el, k) => {
        if (k !== index) {
          this.address[k].default = false;
        } else this.address[k].default = true;
      });
    },
    saveAllAddress(dontclose = false) {
      var data = {
        memberId: this.$store.state.member.memberId,
        address: this.$store.state.address, // Object ไม่ต้อง stringify
      };
      this.autoDefault();
      this.saveloading = true;
      axios
        .put(this.serverUrl + "toacrm/member-address", data, {
          headers: {
            AUTHORIZATION: "Bearer xxx xxx",
          },
        })
        .then((response) => {
          this.saveloading = false;
          if (response.data.responsecode == 200) {
            this.tempaddress = JSON.stringify(this.address);
            if (dontclose !== true) {
              this.$swal.fire({
                text: "สำเร็จ",
                icon: "success",
              });
              this.$emit("close");
            }
          }
        });
    },
    onCreateAddress(payload) {
      this.$store.state.address.push(payload);
      this.saveAllAddress(true);
    },
    onEditAddress(payload) {
      this.$store.state.address[this.editingIndex] = payload;
      this.saveAllAddress(true);
    },
    createAddress() {
      this.editType = "create";
      this.isEdit = true;
    },
    editAddress(address, k) {
      this.editingAddress = address;
      this.editingIndex = k;
      this.editType = "edit";
      this.isEdit = true;
    },
  },
};
</script>

<style lang="scss" scoped></style>
